import { Dialog, Button } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router'
import DialogActions from '@/components/DialogActions'
import useGetPlanKey from '@/hooks/use-get-plan-key'
import { DialogEventHandler } from '@/types'
import DialogContent from './content'

type Props = {
  visible: boolean
  closeModal: DialogEventHandler
}

const TenantScreening = ({ visible, closeModal }: Props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const planText = useGetPlanKey()
  const id = `usage-credit-${planText}-listing-dialog-tenant-screening-continue`

  const handleNavigate = (listingId: string) => {
    if (listingId) {
      history.push(`/listing/${listingId}/applications`)
    }
  }
  const handleClose = () => {
    closeModal()
  }
  return (
    <Dialog
      id="tenantScreeningDialog"
      title={t('b.usage.dialog.tenant_screening_report.title', 'Tenant Screening Report')}
      open={visible}
      onClose={handleClose}
    >
      <Formik
        initialValues={{ listing: '' }}
        onSubmit={value => {
          handleNavigate(value.listing)
        }}
        validationSchema={Yup.object().shape({
          listing: Yup.string().required(
            t('b.usage.credits.error.text', 'Please select at least 1 listing to continue.')
          )
        })}
      >
        {({ values, handleSubmit }) => (
          <Form>
            <DialogContent value={values.listing} />
            <DialogActions>
              <Button type="submit" variant="solid" onClick={handleSubmit} id={id}>
                {t('b.usage.dialog.continue.title', 'Continue')}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default TenantScreening
